// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer__-lcoal-__268PT","FooterLinkText":"Footer__-lcoal-__-wL3P"};